module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-userInfo"
  }, [_c('img', {
    staticClass: "user-icon",
    attrs: {
      "src": _vm.userInfo.portrait
    },
    on: {
      "error": _vm.handleImgError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "user-info-name"
  }, [_vm._v(_vm._s(_vm.userInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "user-info-coin"
  }, [_vm._v(_vm._s(_vm.userInfo.coin) + "钢镚")])]), _vm._v(" "), _c('div', {
    staticClass: "spring"
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.handleTopUp
    }
  }, [_c('img', {
    staticClass: "user-topup",
    attrs: {
      "src": require("../../assets/header_topUp.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-search-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    staticClass: "header-search-content",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }, _vm.change],
      "keydown": function($event) {
        _vm.keydown($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "header-search-clear",
    attrs: {
      "src": require("../../assets/search_clear.png")
    },
    on: {
      "click": _vm.clear
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-divider"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2227ffd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/NIMianHead.vue
// module id = 492
// module chunks = 1